import { render, staticRenderFns } from "./feeListByBatch.vue?vue&type=template&id=1b5c0b63&scoped=true&lang=html&"
import script from "./feeListByBatch.vue?vue&type=script&lang=js&"
export * from "./feeListByBatch.vue?vue&type=script&lang=js&"
import style0 from "./feeListByBatch.vue?vue&type=style&index=0&id=1b5c0b63&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5c0b63",
  null
  
)

export default component.exports